'use strict';

(function () {
    angular
        .module('crewing')
        .component('crewFilterCriteriaDisplay', {
            templateUrl: 'crewing/components/crew-filter-criteria-component.tpl.html',
            controller: function ($timeout, $scope) {
                var vm = this;
                vm.model = {
                    flights : '',
                    leaves  : '',
                    destinations : '',
                    events : '',
                    date : ''
                }

                vm.$onChanges = function (changeObj) {
                    if(changeObj.filterModel && changeObj.filterModel.currentValue && (changeObj.filterModel.currentValue != changeObj.filterModel.previousValue)) {

                        vm.model.flights =  getFlightNumbers(changeObj.filterModel.currentValue.flightNumbers).join(',');
                        vm.model.leaves =  changeObj.filterModel.currentValue.leaves.join(',');
                        vm.model.destinations =  changeObj.filterModel.currentValue.destinations.join(',');
                        vm.model.events =  changeObj.filterModel.currentValue.events.join(',');
                        vm.model.date =  changeObj.filterModel.currentValue.date;

                        if(changeObj.filterModel.currentValue.allLeaves){
                            vm.model.leaves = 'All';
                        }

                        if(changeObj.filterModel.currentValue.allEvents){
                            vm.model.events = 'All';
                        }
                    }
                }

                vm.onCloseFilterClick = function () {
                    vm.onCloseFilter.call();
                }

                function getFlightNumbers(flights) {
                  var flightNumbers=[];
                  var flight=""
                  angular.forEach(flights,function (value) {
                    flight=flight + "," + value.flightNumber

                  });
                  flightNumbers.push(flight);

                  return flightNumbers;

                }
            },
            bindings: {
                filterModel : '<',
                onCloseFilter : '&'
            }
        });
})
();
